import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconCloseBold';
/** Renders an SVG icon. */
const SvgCloseBold = ({
  size,
  'aria-hidden': ariaHidden,
  tone,
  UNSAFE_className,
  UNSAFE_style,
  ...rest
}: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M5.586 5.586a2 2 0 0 1 2.828 0L16 13.172l7.586-7.586a2 2 0 1 1 2.828 2.828L18.828 16l7.586 7.586a2 2 0 1 1-2.828 2.828L16 18.828l-7.586 7.586a2 2 0 1 1-2.828-2.828L13.172 16 5.586 8.414a2 2 0 0 1 0-2.828"
      />
    </svg>
  );
};
SvgCloseBold.displayName = displayName;
export default SvgCloseBold;
